var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-days-work",class:{ active: _vm.active },attrs:{"type":"button"}},[_vm._v(" "+_vm._s(_vm.dayOfTheWeek.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }